import React from "react"
import { batch } from "@preact/signals-react"

import { AppSitesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { mainSite, sites } from "@signals"


/** The main site, and out of the compared sites (it cannot be compared with itself). */
export const setMainSite = (value) => batch(() => {
	mainSite.value = value
	sites.value = Array.isArray(sites.value) ? sites.value.filter(op => value !== op) : (sites.value === value ? null : sites.value)
})

// `onPick(value)`: told after every change, the user's or the list's (the analyzers tell a clear apart, CU-869fmm949)
export default function MainSitesAutocomplete({ onPick, ...props }) {
	return <AppSitesAutocomplete
		multiple={false}
		label="Main sites"
		placeholder="All main sites"
		value={mainSite.value}
		onChange={e => batch(() => {
			setMainSite(e.target.value)
			onPick?.(e.target.value)
		})}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/sites`}
		{...props}
	/>
}
